import { getIconSvgContent as e, hasIconAsset as t, init_iconAssets as n } from "./iconAssets.es.js";
// libs/ui-lib/src/lib/customIcons.ts
n();
function r(e) {
	let t = e.match(/<svg\b[^>]*>/i);
	if (!t) return e;
	let n = t[0], r = n.replace(/\swidth\s*=\s*"[^"]*"/gi, "").replace(/\sheight\s*=\s*"[^"]*"/gi, "");
	return r = r.replace(/>$/, " width=\"100%\" height=\"100%\">"), e.replace(n, r);
}
var i = {};
function a(e, t) {
	return i[e] = {
		svgContent: t,
		name: e
	}, e;
}
function o(e) {
	let t = [];
	for (let [n, r] of Object.entries(e)) a(n, r), t.push(n);
	return t;
}
function s(n) {
	if (n in i) return i[n];
	if (t(n)) {
		let t = e(n);
		if (t) {
			let e = {
				name: n,
				svgContent: r(t),
				isAsset: !0
			};
			return i[n] = e, e;
		}
	}
}
function c(e) {
	return e in i || t(e);
}
export { s as getCustomIcon, c as hasCustomIcon, a as registerCustomIcon, o as registerCustomIcons };
